import { UseQueryResult } from '@tanstack/react-query';
import { warehouseApi } from 'src/api/warehouse';
import {
  PaginatedWarehouseMovementsDto,
  WarehouseProductDetailDto,
} from 'woofwoof-api';
import { warehouseRequestOptions } from '../utils/request';
import { useWarehouseQuery } from './useWarehouseQuery';

/** Key `['warehouse-product', organizationId, productId]`. */
export function useWarehouseProduct(
  productId: string,
): UseQueryResult<WarehouseProductDetailDto> {
  return useWarehouseQuery(
    'warehouse-product',
    [productId],
    async (organizationId, signal) =>
      (
        await warehouseApi.warehouseProductControllerGetProduct(
          { id: productId },
          warehouseRequestOptions(organizationId, signal),
        )
      ).data,
    { enabled: Boolean(productId), retry: false },
  );
}

/**
 * Key `['warehouse-product', organizationId, productId, 'movements', page,
 * rowsPerPage]`; `keepPreviousData` never crosses an organization boundary
 * (S3, handled by `useWarehouseQuery` itself).
 */
export function useWarehouseProductMovements(
  productId: string,
  page: number,
  rowsPerPage: number,
): UseQueryResult<PaginatedWarehouseMovementsDto> {
  return useWarehouseQuery(
    'warehouse-product',
    [productId, 'movements', page, rowsPerPage],
    async (organizationId, signal) =>
      (
        await warehouseApi.warehouseProductControllerListMovements(
          { id: productId, page, limit: rowsPerPage },
          warehouseRequestOptions(organizationId, signal),
        )
      ).data,
    { enabled: Boolean(productId), keepPreviousData: true },
  );
}
